import React from "react";
import { StyleSheet } from "react-native";
import { useNavigation } from "@react-navigation/native";
import { Text } from "../utils/fontsLoader";
import { useTheme } from "react-native-paper";
import PropTypes from "prop-types";

const LinkText = ({ children, style, ...props }) => {
  const theme = useTheme();
  const navigation = useNavigation();
  const styles = stylesGen(theme);

  // Fonction pour détecter et gérer les liens
  const renderText = (inputText) => {
    const parts = inputText.split(/\[([^\]]+)\]\(([^)]+)\)/);
    return parts.map((part, index) => {
      if (index % 3 === 1) {
        return (
          <Text key={index} onPress={() => navigation.navigate(parts[index + 1])} style={[styles.link, style]}>{part}</Text>
        );
      } else if (index % 3 === 0) {
        return <Text key={index} style={style}>{part}</Text>;
      }
      return null;
    });
  };

  // Assurez-vous que les enfants sont de type string
  if (typeof children === "string") {
    return (
      <Text {...props}>
        {renderText(children)}
      </Text>
    );
  }

  // Si les enfants ne sont pas de type string, retournez-les directement
  return children;
};

LinkText.propTypes = {
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  style: PropTypes.object,
};

const stylesGen = (theme) => StyleSheet.create({
  link: {
    color: theme.colors.primary, // Définissez ici le style de votre lien
    textDecorationLine:"underline"
  },
});

export default LinkText;
